// App
import React from 'react';
import styled from 'styled-components';

// Component
import SharedMarketingBlurb from 'app/shared/modules/SeoFooter/MarketingBlurb';

// Utils / Misc
import { colors } from 'app/shared/styles/_colors';

const StyledBlurbContainer = styled.article`
  padding: 40px 16px;
  background: ${colors['$hpx-grey-100']};
  border-top: 1px solid ${colors['$hpx-grey-500']};
`;

const FooterMarketingBlurb = () => {
  return (
    <StyledBlurbContainer>
      <SharedMarketingBlurb />
    </StyledBlurbContainer>
  );
};

export default FooterMarketingBlurb;
